<template>
  <div>
    <v-navigation-drawer v-model="navDrawer"
                        app
                        clipped>
      <v-text-field outlined dense
                    hide-details
                    v-model="stateFilter"
                    class="ma-3"
                    placeholder="Type to filter states"></v-text-field>
      <v-divider class="mt-2"></v-divider>
      <v-list class="pt-0">
        <v-list-item v-for="(state, index) in filteredStates"
                    :key="index"
                    :to="`/states/${state.propName}`">
          <v-list-item-content>
            <v-list-item-title>{{ state.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-fade-transition mode="out-in">
      <router-view></router-view>
    </v-fade-transition>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      headers: ['date', 'state', 'flips', 'cases', 'deaths'],
      covidRawData: [],
      stateFilter: ''
    }
  },
  computed: {
    navDrawer: {
      get() {
        return this.$store.getters.getNavDrawer
      },
      set(val) {
        this.$store.commit('setNavDrawer', val)
      }
    },
    filteredStates() {
      return this.$store.getters.getListOfStates.filter(state => state.name.toLowerCase().includes(this.stateFilter.toLowerCase()))
    }
  },
  created() {
    if (document.title === 'covid19charts' && typeof this.$route.params.state === 'undefined') {
      document.title = 'Covid-19 Data Visualizer'
    } else if (document.title === 'covid19charts') {
      document.title = 'Covid-19 Data Visualizer'
    }
    this.axios.get(`https://raw.githubusercontent.com/nytimes/covid-19-data/master/us-states.csv`)
      .then((response) => {
        this.covidRawData = this.convertCsvToJson(response.data, this.headers)
        this.$store.commit('saveCovidData', this.objectifyData(this.covidRawData))
      }, (error) => {
        alert('There was an error while fetching the dataset. Please try again later.')
      })
  },
  methods: {
    objectifyData(arr) {
      let dataObj = {}
      this.$store.getters.getListOfStates.forEach(listedState => {
        let stateDataPoints = arr.filter(rawData => rawData.state === listedState.name)
        let stateProp = this.$store.getters.getListOfStates.find(state => state.name === listedState.name).propName
        let stateObj = {}
        stateObj[stateProp] = []

        dataObj[stateProp] = {}
        stateDataPoints.forEach(dataPoint => {
          let obj = {
            flips: dataPoint.flips,
            cases: dataPoint.cases,
            deaths: parseInt(dataPoint.deaths)
          }
          dataObj[stateProp][dataPoint.date] = obj
        })
      })
      return dataObj
    },
    convertCsvToJson(str, headerList) {
      const cutlast = (_, i, a) => i < a.length - 1;
      // const regex = /(?:[\t ]?)+("+)?(.*?)\1(?:[\t ]?)+(?:,|$)/gm; // no variable chars
      const regex = new RegExp(`(?:[\\t ]?)+("+)?(.*?)\\1(?:[\\t ]?)+(?:,|$)`, 'gm')
      const lines = str.split('\n')
      const headers = headerList || lines.splice(0, 1)[0].match(regex).filter(cutlast)

      const list = []

      for (const line of lines) {
        const val = {}
        for (const [i, m] of [...line.matchAll(regex)].filter(cutlast).entries()) {
          // Attempt to convert to Number if possible, also use null if blank
          val[headers[i]] = (m[2].length > 0) ? Number(m[2]) || m[2] : null
        }
        list.push(val)
      }

      return list
    }
  }
}
</script>
